module.exports = __webpack_public_path__ + "img/3.22745ac7.jpg";